<template>
    <div class="webmd-loading-mask auth-spinner" style="background-color: rgba(0, 0, 0, 0.7);">
        <div class="webmd-loading-spinner">
            <div class="webmd-loading-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="85" height="20" viewBox="0 0 85 20" class="webmd-loader-logo">
                    <g fill="none" fill-rule="evenodd">
                    <path fill="#0078BF" d="M39.491 14.248c-.625 1.227-1.441 2.396-2.347 3.292-.968.947-2.05 1.566-3.132 1.566-1.268 0-1.682-1.21-1.682-2.338 0-3.08 3.363-8.803 6.782-8.803 1.267 0 1.653.88 1.653 1.928 0 1.191-.487 2.807-1.274 4.355m-12.56-6.53c.717 0 1.13.47 1.13 1.183 0 3-3.335 4.319-5.873 4.485.443-1.815 2.62-5.667 4.742-5.667m12.924-.88c-2.479 0-4.74 2.255-6.228 3.96-.03-.03.132-.68.36-1.445l2.311-7.732C36.527.856 36.058.23 35.258.23L33.305.225c-.935 0-1.366.013-1.308.408.033.215.36.277.503.318.927.259 1.233 1.297.988 2.415.009-.092-2.312 9.143-2.312 9.143-.19.775-.883 1.866-1.46 2.42 0 0-2.8 3.407-5.626 3.407-1.295 0-2.26-.742-2.26-2.117 0-.716.053-1.336.218-2.053 2.95-.275 8.22-1.633 8.22-5.374 0-1.512-1.462-1.953-2.703-1.953-3.997 0-7.94 4.868-7.94 9.27 0 1.843.854 3.713 3.391 3.713 4.767 0 7.357-4.644 7.503-4.799 0 0-.23 1.167-.23 1.857 0 2.008 1.463 2.942 3.283 2.942 1.329 0 2.723-.474 4.036-1.259a11.884 11.884 0 0 0 2.775-2.345c1.545-1.743 2.588-3.886 2.588-5.887 0-2.09-.91-3.492-3.117-3.492M23.12 2.187c.13-.342.422-1 .831-1.21.212-.11.625-.104.694-.393.07-.287-.186-.364-1.203-.364h-3.051c-.933 0-1.366.013-1.307.407.032.215.358.278.502.318.883.247 1.478.698 1.2 1.62-.277.924-4.131 12.247-4.131 12.247-.15.407-.524.523-.642-.083l-2.03-9.522a48.502 48.502 0 0 1-.423-2.225s-.143-.624-.86-.624a.9.9 0 0 0-.842.514c-.258.535-.765 1.556-1.128 2.269l-5.085 9.74c-.207.363-.473.255-.505-.179l-.63-9.876c-.005-.778-.076-2.291-.073-2.552.002-.649.432-1.148 1.041-1.318.145-.04.49-.122.523-.337.06-.393-.392-.388-1.328-.388H1.295a6.4 6.4 0 0 0-.463.003c-.63.013-.919.078-.87.404.033.214.358.278.502.318.423.118.713.4.884.777.082.219.13.407.13.407l.015.073c.004.02.01.04.012.061a22.063 22.063 0 0 1 .397 2.73l.819 12.066c.052.798.027 1.954.267 2.456.24.5 1.365.472 1.81-.2.126-.19 6.468-12.085 6.468-12.085.37-.709.802-.647.962.135l1.998 9.808c.158.783.326 1.653.52 2.156.274.71 1.631.584 1.991-.107.319-.605.652-1.432.924-2.183 0 0 5.222-14.238 5.459-14.863"></path>
                    <path fill="#222" d="M83.383 1.302V.886h.276c.143 0 .295.03.295.197 0 .206-.156.22-.329.22h-.242zm0 .172h.234l.356.582h.228l-.383-.59c.196-.027.348-.13.348-.37 0-.266-.158-.383-.476-.383h-.512v1.343h.205v-.582zm.246 1.075c.636 0 1.179-.493 1.179-1.168 0-.668-.543-1.161-1.179-1.161-.643 0-1.185.493-1.185 1.161 0 .675.542 1.168 1.185 1.168zm-.95-1.168c0-.55.417-.967.95-.967.528 0 .944.416.944.967 0 .561-.416.974-.944.974-.533 0-.95-.413-.95-.974zM65.07 18.758c-.577-.201-1.016-.88-1.028-1.228-.011-.348-.365-15.773-.365-15.773-.016-.799.021-1.38-.193-1.46-.259-.097-1.352-.074-1.64-.074-.698 0-1.214-.018-1.34.128-.135.156-.388.71-.672 1.457l-1.414 3.143c-.366.71-.99 1.922-1.357 2.63l-2.145 4.15c-.368.71-.98.718-1.365.016L51.31 7.645l-1.393-2.552-1.573-3.313c-.317-.733-.47-1.303-.626-1.44-.132-.118-.692-.118-1.493-.113h-1.88c-.935 0-1.356.01-1.295.404.032.216.358.278.501.318.58.163.791.868.791 1.217 0 .348-.01 14.4-.078 15.016a4.146 4.146 0 0 1-.053.318c-.003.011-.009.022-.012.036-.11.6-.457 1.06-1.037 1.222-.143.04-.47.102-.501.318-.06.394.373.407 1.307.407l1.547-.002 1.547.002c.934 0 1.368-.013 1.308-.407-.033-.216-.358-.278-.501-.318-.58-.162-.816-.527-1.028-1.228 0-.003-.003-.006-.003-.01-.102-.453-.15-1.064-.15-1.064-.03-.8-.049-2.106-.04-2.905l.002-.246c.008-.8.03-2.107.049-2.904l.074-3.149c.018-.799.343-.877.722-.173l2.082 3.857c.38.704 2.375 4.47 2.731 5.183.303.606.366.833 1.302.846 1.048.012 1.048-.278 1.479-1.2.315-.677 4.779-9.441 4.779-9.441.364-.712.678-.64.7.158 0 0 .056 10.687-.019 11.167l-.028.161c-.153.462-.467.812-.952.948-.144.04-.468.102-.502.318-.058.394.373.407 1.307.407l1.945-.003 1.944.003c.937 0 1.368-.013 1.308-.407-.033-.216-.36-.269-.501-.318m8.25-.963l-.183.001c-1.113 0-2.263.003-2.859-.589-.308-.31-.458-.764-.458-1.391V6.97c0-1.822-.045-2.68.016-4.723 1.429-.177 2.148-.225 3.315-.225 2.105 0 4.307.283 6.147 2.322 1.257 1.414 1.87 3.18 1.87 5.396 0 4.892-3.082 8.055-7.848 8.055M81.39 2.09C78.94.161 74.287.26 74.287.26c-.81.002-2.637-.007-3.437 0L68.346.255c-.01 0-.018-.004-.026-.004L66.256.25c-.935 0-1.257.066-1.198.46.033.215.36.278.504.318.578.162 1.002.472 1.026 1.046.03.662.104 2.744.104 3.466v5.912c0 .799-.003 2.107-.006 2.904l-.014 3.676a1.456 1.456 0 0 0 1.45 1.454l1.86.003c.8.002 2.11.003 2.911.003 0 0 3.429.004 5.92-1.145 3.734-1.69 5.874-4.949 5.874-8.94 0-2.979-1.232-5.713-3.297-7.317"></path>
                    </g>
                </svg>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
$color_1: #767674;
$color_2: #409EFF;
$font-family_1: "Source Sans Pro",Tahoma,sans-serif;
@-webkit-keyframes loading-rotate {
	100% {
		-webkit-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
@keyframes loading-rotate {
	100% {
		-webkit-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
@-webkit-keyframes loading-dash {
	0% {
		stroke-dasharray: 1,200;
		stroke-dashoffset: 0;
	}
	50% {
		stroke-dasharray: 90,150;
		stroke-dashoffset: -120px;
	}
	100% {
		stroke-dasharray: 90,150;
		stroke-dashoffset: -120px;
	}
}
@keyframes loading-dash {
	0% {
		stroke-dasharray: 1,200;
		stroke-dashoffset: 0;
	}
	50% {
		stroke-dasharray: 90,150;
		stroke-dashoffset: -120px;

	}
	100% {
		stroke-dasharray: 90,150;
		stroke-dashoffset: -120px;
	}
}
.webmd-loading-parent--relative {
	position: relative !important;
}
.webmd-loading-parent--hidden {
	overflow: hidden !important;
}
.webmd-loading-mask {
	position: absolute;
	z-index: 2000;
	background: #fff;
	background: radial-gradient(ellipse at center,#fff 0,#f7f7f7 20%,#dff4fb 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#ddf3fb', GradientType=1 );
	margin: 0;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	-webkit-transition: opacity .3s;
	transition: opacity .3s;
}
.webmd-loading-mask.is-fullscreen {
	position: fixed;
	.webmd-loading-spinner {
		margin-top: -5.4375rem;
		.webmd-loading-icon {
			position: relative;
			height: 10.875rem;
			width: 10.875rem;
			margin: 0 auto;
			&:before {
				-webkit-animation: loading-rotate 1s linear infinite;
				animation: loading-rotate 1s linear infinite;
				border-radius: 50%;
				-webkit-box-shadow: 0 .25rem 0 0 #a3d7e9;
				box-shadow: 0 .25rem 0 0 #a3d7e9;
				content: '';
				height: 10rem;
				left: calc(50% - 5rem);
				position: absolute;
				top: calc(50% - 5rem);
				-webkit-transform-origin: 5rem 5.125rem;
				transform-origin: 5rem 5.125rem;
				width: 10rem;
			}
		}
		.circular {
			height: 10.875rem;
			width: 10.875rem;
		}
	}
}
.webmd-loading-spinner {
	top: 50%;
	margin-top: -5.4375rem;
	width: 100%;
	text-align: center;
	position: absolute;
	.webmd-loading-icon {
		position: relative;
		height: 10.875rem;
		width: 10.875rem;
		margin: 0 auto;
		&:before {
			-webkit-animation: loading-rotate 1s linear infinite;
			animation: loading-rotate 1s linear infinite;
			border-radius: 50%;
			-webkit-box-shadow: 0 .25rem 0 0 #a3d7e9;
			box-shadow: 0 .25rem 0 0 #a3d7e9;
			content: '';
			height: 10rem;
			left: calc(50% - 5rem);
			position: absolute;
			top: calc(50% - 5rem);
			-webkit-transform-origin: 5rem 5.125rem;
			transform-origin: 5rem 5.125rem;
			width: 10rem;
		}
	}
	.webmd-loading-text {
		color: $color_1;
		margin: 1.29375rem 0;
		font-family: $font-family_1;
		font-size: .9375rem;
	}
	.circular {
		height: 10.875rem;
		width: 10.875rem;
		-webkit-animation: loading-rotate 2s linear infinite;
		animation: loading-rotate 2s linear infinite;
	}
	.webmd-loader-logo {
		margin-top: calc(50% - .625rem);
	}
	.path {
		-webkit-animation: loading-dash 1.5s ease-in-out infinite;
		animation: loading-dash 1.5s ease-in-out infinite;
		stroke-dasharray: 90,150;
		stroke-dashoffset: 0;
		stroke-width: .125rem;
		stroke: #409EFF;
		stroke-linecap: round;
	}
	i {
		color: $color_2;
	}
}
.webmd-loading-fade-enter {
	opacity: 0;
}
.webmd-loading-fade-leave-active {
	opacity: 0;
}
</style>